const I = 56, E = 46, T = 80, _ = 8, P = 18, H = 240;
export {
  T as INPUT_EXPRESSIVE_HEIGHT,
  _ as INPUT_EXPRESSIVE_X_PADDING,
  I as INPUT_PRODUCTIVE_HEIGHT,
  E as INPUT_PRODUCTIVE_HEIGHT_SMALL,
  P as INPUT_PRODUCTIVE_X_PADDING,
  H as TEXTAREA_HEIGHT
};
